<script>
export default {
  name: 'Stage',
  props: {
    stage: {
      type: Number,
      default: 0,
    },
    query: {
      type: Object,
      default: () => {},
    }
  },
  // emits: ['update-stage'],
  methods: {
    updateStage(newStage) {
      if (this.stage <= newStage) {
        return
      }
      switch (newStage) {
        case 1:
          this.$router.push({
            path: '/salon/order/edit',
            query: this.query,
          })
          break
        case 2:
          this.$router.push({
            path: '/salon/order/time',
            query: this.query,
          })
          break
        default:
          break
      }
    },
  },
}
</script>

<template>
  <div class="container">
    <div class="wrapper">
      <div @click="updateStage(1)" class="step">
        <div :class="stage >= 1 ? 'currentBorder' : 'otherBorder'">
          <div :class="stage >= 1 ? 'currentInner' : 'otherInner'">
            <img v-if="stage > 1" src="@/assets/images/complete.svg" />
            <div v-else>1</div>
          </div>
        </div>
        <p :class="{ currentWord: stage === 1 }" class="word">填寫資料</p>
      </div>
      <div :class="{ currentLine: stage > 1 }" class="line"></div>
      <div @click="updateStage(2)" class="step">
        <div :class="stage >= 2 ? 'currentBorder' : 'otherBorder'">
          <div :class="stage >= 2 ? 'currentInner' : 'otherInner'">
            <img v-if="stage > 2" src="@/assets/images/complete.svg" />
            <div v-else>2</div>
          </div>
        </div>
        <p :class="{ currentWord: stage === 2 }" class="word">預約日期</p>
      </div>
      <div :class="{ currentLine: stage > 2 }" class="line"></div>
      <div class="step">
        <div :class="stage >= 3 ? 'currentBorder' : 'otherBorder'">
          <div :class="stage >= 3 ? 'currentInner' : 'otherInner'">
            <div>3</div>
          </div>
        </div>
        <p :class="{ currentWord: stage === 3 }" class="word">確認預約</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  width: 100%;
  display: flex;
  padding: 20px 24px;
}
.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
}
.step {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.line {
  border-radius: 2px;
  height: 2px;
  width: 100%;
  background-color: #ccc;
}
.currentBorder {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  width: 28px;
  height: 28px;
  padding: 1.88px;
  background: linear-gradient(215deg, #f9d5c3 0%, #ff9f4b 100%);
  border-radius: 100%;
  font-family: Noto Sans TC !important;
}
.currentInner {
  background: #ff9f4b;
  border-radius: 100%;
  font-weight: 700;
  width: 100%;
  height: 100%;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Noto Sans TC !important;
}
.otherBorder {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  width: 28px;
  height: 28px;
  padding: 1.88px;
  background: #cccccc;
  border-radius: 100%;
  font-family: Noto Sans TC !important;
}
.otherInner {
  background: #f6f6f6;
  border-radius: 100%;
  font-weight: 700;
  width: 100%;
  height: 100%;
  color: #cccccc;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Noto Sans TC !important;
}
.word {
  top: 100%;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
  line-height: 12.25px;
  text-align: center;
  letter-spacing: -0.44px;
  margin-bottom: 0px !important;
  white-space: nowrap;
  transform: translateY(5.25px);
  color: #909090;
}
.currentWord {
  color: #d16200;
}
.currentLine {
  background-color: #ff9f4b;
}
</style>
